export default __webpack_public_path__ + "media/images/cursor-9c6ba57a.png";